module.exports = __webpack_public_path__ + "media/images/pets4-d9a4b5191628b8ceadc647b23fe44226.jpg";